import Snackbar from "@material-ui/core/Snackbar";
import './NotifBar.css'
export default function NotifBar(props) {
    return <Snackbar 
        {...props}
        className='t-notif-bar'
        />
}